import React, { useCallback, useEffect, useState } from 'react';
import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
// import ClassicEditor from '@rastech-inc/ckeditor';
import { appDispatch, IProviders, IThisUser, RootState } from 'store/store';
import {
  requireDocument,
  requireDocumentFn,
} from 'store/providers/providerSlice';
import { DataContextProvider } from 'store/context/DataContext';
import { TaskFileBrowseIcon, TaskFilePickerWrapper } from './styles';
import Icon from 'components/Icon';
import ClassDocumentItem from './ClassDocumentItem';
import TaskFileExplorerModal from '../../../TasksManagement/TaskFileExplorerModal/TaskFileExplorerModal';
import TaskItemsViewer from '../../../TasksManagement/TaskItemsViewer';
import notify from '../../../../../components/Notify';
import cloneDeep from 'lodash/cloneDeep';
import APopover from '../../../../../components/APopover';
import CKEditorField, {
  CkEditorBaseConfig,
  CKEditorReadOnlyConfig,
} from '../../../../../components/CKEditorField/CKEditorField';
import Input from '../../../../../components/Input/Input';
import {
  ClassDocument,
  ClassPhaseProp,
  ICompanyProviders,
} from 'store/companies/companiesTypes';
import {
  IProviderItemView,
  IProviderItemViewWithData,
  IRelatedProviderItem,
  ITags,
  ProviderItemType,
} from 'store/providers/providerTypes';
import { getAccessToken } from '../../../../../api/Utils';
import { border1, lightGray } from '../../../../../utils/style/colors';
import { PDPClass, Topic } from '../../../../../store/pdp/types';
import { hashCode } from '../../../../../components/TaskEditorHeader/TaskEditorHeader';
import { DeleteIcon } from '../../../../../components/SurveyResponses/styles';
import { Card } from '../../CompanyRoles/styles';
import Collapsible from '../../../../../components/Collapsible';
import Button from '../../../../../components/Button';
import i18n from '../../../../../i18n';
import { SurveyType } from '../../../../../store/survey/surveyTypes';
import { jitsiUrl } from '../../../../../api/ManApi';

interface IOwnProps {
  phaseEndDate?: number;
  showCorrectAnswers?: boolean;
  items: ClassDocument[] | null;
  onRemove: (item: ClassDocument) => void;
  createQuizSurvey?: (
    name: string,
    type: SurveyType,
    useQuestionBank?: boolean
  ) => Promise<any>;
  onSave: (item: ClassDocument, index: number) => void;
  onCloseSurvey?: () => void;
  inCollapsible?: boolean;
  providers: ICompanyProviders | null;
  editable?: boolean;
  surveyFilterTags?: number[];
  clazz?: PDPClass;
  topic?: Topic;
  phase?: ClassPhaseProp;
}

interface IStateToProps {
  providerItems?: IProviders['items'];
  token?: string;
  thisUser: IThisUser;
  tags: ITags['data'];
}

interface IDispatchToProps {
  requireProviderItem: (
    providerItemId: number,
    token?: string
  ) => ReturnType<typeof requireDocumentFn>;
}

type IComponentProps = IOwnProps & IStateToProps & IDispatchToProps;

const onOpenFolder = (_item: IProviderItemViewWithData) => {
  window.open(`/content/${_item.data.providerId}/f/${_item.data.id}`, '_blank');
};

const onOpenLink = (item: IProviderItemViewWithData) => {
  window.open(`/content/${item.data!.linkedProviderId}`, '_blank');
};

const getOpenFunction: {
  [key in Extract<ProviderItemType, 'link' | 'folder'>]: (
    item: IProviderItemViewWithData
  ) => void;
} = {
  // document: onOpenDocument,
  folder: onOpenFolder,
  link: onOpenLink,
};

function getCKEditor(
  editable: boolean | undefined,
  setContent: (value: string) => void,
  setTitle: (value: string) => void,
  item: ClassDocument,
  token: string | undefined,
  onRemove: (item: ClassDocument) => void,
  index: number
) {
  return (
    <Card style={{ position: 'relative', flexDirection: 'column' }}>
      {editable && (
        <Input
          id={'title' + index}
          type={'text'}
          value={item.title}
          onChange={(e) => {
            setTitle(e.target.value);
          }}
          label={i18n.t('title', { ns: 'companyManagement' }) as string}
        />
      )}
      <CKEditorField
        label={
          editable
            ? (i18n.t('content', { ns: 'companyManagement' }) as string)
            : item.title
        }
        onChange={(e: string) => {
          if (!editable) return;
          setContent(e);
        }}
        wrapperStyle={{ maxHeight: '90%' }}
        data={item.content}
        // editor={ClassicEditor}
        disabled={!editable}
        style={{
          '--ck-focus-ring': '0px',
          height: '100%',
        }}
        dir="rtl"
        config={editable ? CkEditorBaseConfig(token) : CKEditorReadOnlyConfig}
      />
      {editable && (
        <DeleteIcon
          type={'x'}
          style={{ backgroundColor: lightGray }}
          onClick={() => onRemove(item)}
        />
      )}
    </Card>
  );
}

const onVideoCall = (
  userName: string,
  topicName: string,
  phaseName: string,
  classId: number
) => {
  const hash = hashCode(`${classId}`);
  const roomName = topicName + ':' + phaseName;
  const url = `${jitsiUrl}/rastech-class-${hash}#userInfo.displayName="${userName}"&config.callDisplayName="${roomName}"&config.defaultLanguage="fa"`;
  window.open(url);
};
export const VideoMeetingConst = '%onlineMeeting%';
const ClassFilePicker: React.FC<IComponentProps> = ({
  items,
  onRemove,
  onSave,
  providerItems,
  providers,
  requireProviderItem,
  editable,
  token,
  surveyFilterTags,
  phaseEndDate,
  showCorrectAnswers,
  clazz,
  createQuizSurvey,
  thisUser,
  tags,
  topic,
  onCloseSurvey,
  inCollapsible,
  phase,
}) => {
  const [showFileExplorerModal, setShowFileExplorerModal] = useState(false);
  const [openItem, setOpenItem] = useState<IProviderItemViewWithData | null>(
    null
  );
  useEffect(() => {
    if (!openItem) onCloseSurvey?.();
  }, [openItem]);
  const [openItemProps, setOpenItemProps] = useState<any | null>(null);
  const [loadingItemId, setLoadingItemId] = useState<number | undefined>(
    undefined
  );
  const [selectedItem, setSelectedItem] = useState<ClassDocument | undefined>(
    undefined
  );

  const [addPopUpOpen, setAddPopUpOpen] = useState(false);
  const handleShowFileExplorerModal = () => {
    setShowFileExplorerModal((prevState) => !prevState);
    setAddPopUpOpen(false);
  };
  const [creatingExam, setCreatingExam] = useState(false);
  const createOnlineMeeting = (index: number) => {
    const document: ClassDocument = {
      content: VideoMeetingConst,
      title: i18n.t('joinVideoMeet', {
        ns: 'companyManagement',
      }) as string,
    };
    onSave(document, index);
  };
  const handleShowFileExplorerModalCallback = useCallback(
    handleShowFileExplorerModal,
    []
  );

  const getProviderItem = (item?: ClassDocument) => {
    let existItem: IProviderItemViewWithData | undefined;
    if (providerItems && item) {
      const foundItem =
        providerItems[item.providerId!].items[item.providerItemId!];
      if (foundItem) {
        existItem = foundItem;
      }
    }
    return existItem;
  };

  const getProviderItemCallback = useCallback(getProviderItem, [
    providerItems,
    selectedItem,
  ]);

  const handleOpenItem =
    (item?: ClassDocument) =>
    (e?: React.MouseEvent<HTMLSpanElement, MouseEvent>) => {
      e?.preventDefault();
      setSelectedItem(item);
      if (item) {
        const { type, providerItemId, content } = item;
        if (type === undefined || !providerItemId) {
          if (content) {
            if (content === VideoMeetingConst && clazz && topic) {
              onVideoCall(
                thisUser.name || '',
                topic!.properties.name,
                tags[phase?.phaseTagId || 0]?.text,
                clazz.id!
              );
            } else return;
          } else notify('view not supported', 'warning');
          return;
        }
        const openFunction = getOpenFunction[type] || onOpenItem;

        const itemInStore = getProviderItemCallback(item);

        if (
          itemInStore &&
          providerItemId &&
          (!item.itemChangeDataToken || itemInStore.data.changeDataToken)
        ) {
          const foundItem = { ...itemInStore };
          if (editable) foundItem.state = 'edit';
          else if (foundItem.data.type === 'survey') {
            foundItem.state = 'responses';
          }
          openFunction(foundItem);
        } else {
          setLoadingItemId(providerItemId);
          requireProviderItem(
            providerItemId,
            item.itemChangeDataToken || item.itemToken
          ).then((res) => {
            setLoadingItemId(undefined);
            const item = { data: res.item };
            if (editable) (item as any).state = 'edit';
            else if (item.data.type === 'survey') {
              (item as any).state = 'responses';
            }
            openFunction(item);
          });
        }
      }
    };
  const handleOpenItemCallback = useCallback(handleOpenItem, [
    providerItems,
    items,
  ]);

  const onOpenItem = (item: IProviderItemViewWithData) => {
    const otherProps = {} as any;
    if (item.data.type === 'survey') {
      otherProps.extraTagIds = surveyFilterTags;
      otherProps.extraContext =
        i18n.t('course', { ns: 'pdp' }) + ': ' + topic?.properties.name;
      otherProps.lastPossibleSubmitTime = phaseEndDate;
      otherProps.showCorrectAnswers = showCorrectAnswers;
      otherProps.limitRelatedUsers = Object.values(clazz?.participants || {})
        .filter((it) => it.participantProps.status !== 'Dropped')
        .map((it) => it.userId);
      otherProps.pdpId = topic?.companyPDPId;
      if (
        phase?.phaseTagId &&
        Object.keys(tags).includes(phase.phaseTagId.toString())
      ) {
        otherProps.phase = tags[phase.phaseTagId]?.text;
      } else {
        otherProps.phase =
          i18n.t('course', { ns: 'pdp' }) + ': ' + topic?.properties.name;
      }
    }
    setOpenItemProps(otherProps);
    setOpenItem(item);
  };

  const handleSaveItem = (item: IRelatedProviderItem) => {
    const classItem = cloneDeep(item) as ClassDocument;
    classItem.providerItemId = item.id;
    delete (classItem as any).id;
    onSave(classItem, -1);
    // to store last opened item position
    // setSelectedItem(item);
    setShowFileExplorerModal(false);
  };
  const handleCreateNewPage = () => {
    const document: ClassDocument = {
      content: ' ',
      title: '',
    };
    onSave(document, -1);
    // to store last opened item position
    // setSelectedItem(item);
    // setShowDocumentEditor(false);
  };
  const handleSaveItemCallback = useCallback(handleSaveItem, []);
  const [quizName, setQuizName] = useState('');
  const [useQuestionBank, setUseQuestionBank] = useState(true);
  useEffect(() => {
    setQuizName(
      phase ? tags[phase?.phaseTagId].text + ' ' + topic?.properties?.name : ''
    );
  }, [clazz?.id, phase?.phaseTagId]);
  const body = (
    <TaskFilePickerWrapper>
      {/*{items && items.filter((item) => !!item.content).map((item, index) => {})}*/}
      {items &&
        items.map((item, index) => {
          if (!item.providerId && item.content !== VideoMeetingConst)
            return (
              <span key={index}>
                {getCKEditor(
                  editable,
                  (content) => {
                    onSave({ ...item, content }, index);
                  },
                  (title) => {
                    onSave({ ...item, title }, index);
                  },
                  item,
                  token,
                  onRemove,
                  index
                )}
              </span>
            );
          return (
            <ClassDocumentItem
              large={!editable}
              item={item}
              key={item.providerItemId || -index}
              onOpen={(item) => handleOpenItemCallback(item)}
              isLoading={
                loadingItemId ? loadingItemId === item.providerItemId : false
              }
              onRemove={editable ? onRemove : undefined}
            />
          );
        })}
      <span>
        {editable && (
          <APopover
            arrow
            curveBorder
            placement="bottom"
            usePortal={false}
            trigger="click"
            show={addPopUpOpen}
            onShowChange={setAddPopUpOpen}
            target={
              <TaskFileBrowseIcon>
                <Icon type="plus" />
              </TaskFileBrowseIcon>
            }
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
              }}
            >
              <span
                style={{ cursor: 'pointer' }}
                onClick={handleShowFileExplorerModalCallback}
              >
                <Icon type={'link'} />
                <span style={{ margin: '1px 0', marginInlineStart: '10px' }}>
                  {
                    i18n.t('pickDocument', {
                      ns: 'companyManagement',
                    }) as string
                  }
                </span>
              </span>
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => handleCreateNewPage()}
              >
                <Icon type={'plus'} />
                <span style={{ margin: '1px 0', marginInlineStart: '10px' }}>
                  {
                    i18n.t('createPage', {
                      ns: 'companyManagement',
                    }) as string
                  }
                </span>
              </span>
              <span
                style={{ cursor: 'pointer' }}
                onClick={() => createOnlineMeeting(-1)}
              >
                <Icon type={'video'} />
                <span style={{ margin: '1px 0', marginInlineStart: '10px' }}>
                  {
                    i18n.t('videoMeet', {
                      ns: 'companyManagement',
                    }) as string
                  }
                </span>
              </span>
              {clazz && clazz.properties.phaseProps.length > 1 && (
                <APopover
                  usePortal={false}
                  arrow
                  curveBorder
                  placement={'right'}
                  trigger="click"
                  target={
                    <span style={{ cursor: 'pointer', display: 'flex' }}>
                      <Icon type={'folder'} />
                      <p style={{ margin: '1px 0', marginInlineStart: '10px' }}>
                        {
                          i18n.t('otherPhases', {
                            ns: 'companyManagement',
                          }) as string
                        }
                      </p>
                    </span>
                  }
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      maxWidth: '300px',
                    }}
                  >
                    {clazz.properties.phaseProps
                      .filter(
                        (p) =>
                          (p.phaseTagId !== phase?.phaseTagId ||
                            p.phaseStageId !== phase?.phaseStageId) &&
                          p.phaseDocuments?.length
                      )
                      .map((otherPhase) => (
                        <div key={otherPhase.phaseTagId}>
                          <div
                            style={{
                              fontWeight: 'bold',
                              padding: '5px',
                              borderBottom: border1,
                            }}
                          >
                            {tags[otherPhase.phaseTagId]?.text ||
                              `Phase ${otherPhase.phaseTagId}`}
                          </div>
                          {otherPhase.phaseDocuments.map((doc, docIndex) => (
                            <div
                              key={docIndex}
                              className="cursor-pointer p-2 flex items-center hover:bg-gray-100"
                              onClick={() => {
                                onSave(doc, -1);
                                setAddPopUpOpen(false);
                              }}
                            >
                              <Icon
                                type={
                                  doc.type === 'survey'
                                    ? 'check'
                                    : doc.content === VideoMeetingConst
                                      ? 'video'
                                      : 'file'
                                }
                              />
                              <span
                                style={{
                                  marginInlineStart: '8px',
                                  fontSize: '14px',
                                }}
                              >
                                {doc.title || 'Untitled Document'}
                              </span>
                            </div>
                          ))}
                        </div>
                      ))}
                  </div>
                </APopover>
              )}
              {createQuizSurvey && (
                <>
                  <APopover
                    usePortal={true}
                    arrow
                    curveBorder
                    target={
                      <span style={{ cursor: 'pointer', display: 'flex' }}>
                        <Icon type={'check'} />

                        <p
                          style={{ margin: '1px 0', marginInlineStart: '10px' }}
                        >
                          {
                            i18n.t('createExam', {
                              ns: 'companyManagement',
                            }) as string
                          }
                        </p>
                      </span>
                    }
                  >
                    <div style={{ width: '200px', padding: '1rem' }}>
                      <Input
                        id={'quizName'}
                        type="text"
                        value={quizName}
                        onChange={(e) => setQuizName(e.target.value)}
                        label={
                          i18n.t('quizName', {
                            ns: 'companyManagement',
                          }) as string
                        }
                      ></Input>
                      <Input
                        id={'useQuestionBank'}
                        type="checkbox"
                        checked={useQuestionBank}
                        onChange={(e) => setUseQuestionBank(e.target.checked)}
                        label={
                          i18n.t('useQuestionBank', {
                            ns: 'companyManagement',
                          }) as string
                        }
                      />
                      <Button
                        loading={creatingExam}
                        disabled={!quizName.trim().length}
                        onClick={() => {
                          setCreatingExam(true);
                          createQuizSurvey(
                            quizName,
                            'Exam',
                            useQuestionBank
                          ).then((item: IProviderItemView) => {
                            setCreatingExam(false);
                            const document: ClassDocument = {
                              type: 'survey',
                              providerItemId: item.id,
                              title: item.name!,
                              providerId: item.providerId,
                            };
                            onSave(document, -1);
                            handleOpenItem(document)();
                            setAddPopUpOpen(false);
                          });
                        }}
                      >
                        {
                          i18n.t('createExam', {
                            ns: 'companyManagement',
                          }) as string
                        }
                      </Button>
                    </div>
                  </APopover>
                  <APopover
                    usePortal={true}
                    arrow
                    curveBorder
                    target={
                      <span style={{ cursor: 'pointer', display: 'flex' }}>
                        <Icon type={'check'} />

                        <p
                          style={{ margin: '1px 0', marginInlineStart: '10px' }}
                        >
                          {
                            i18n.t('createChecklist', {
                              ns: 'companyManagement',
                            }) as string
                          }
                        </p>
                      </span>
                    }
                  >
                    <div style={{ width: '200px', padding: '1rem' }}>
                      <Input
                        id={'checkListName'}
                        type="text"
                        value={quizName}
                        onChange={(e) => setQuizName(e.target.value)}
                        label={
                          i18n.t('checkListName', {
                            ns: 'companyManagement',
                          }) as string
                        }
                      ></Input>
                      <Button
                        loading={creatingExam}
                        disabled={!quizName.trim().length}
                        onClick={() => {
                          setCreatingExam(true);
                          createQuizSurvey(quizName, 'Regular').then(
                            (item: IProviderItemView) => {
                              setCreatingExam(false);
                              const document: ClassDocument = {
                                type: 'survey',
                                providerItemId: item.id,
                                title: item.name!,
                                providerId: item.providerId,
                              };
                              onSave(document, -1);
                              handleOpenItem(document)();
                              setAddPopUpOpen(false);
                            }
                          );
                        }}
                      >
                        {
                          i18n.t('createChecklist', {
                            ns: 'companyManagement',
                          }) as string
                        }
                      </Button>
                    </div>
                  </APopover>
                </>
              )}
            </div>
          </APopover>
        )}
      </span>

      {providers && showFileExplorerModal && (
        <TaskFileExplorerModal
          onClose={handleShowFileExplorerModalCallback}
          onSave={handleSaveItemCallback}
          providers={providers}
        />
      )}
    </TaskFilePickerWrapper>
  );
  return (
    <span>
      {inCollapsible ? (
        <Collapsible
          header={
            <span>
              <Icon type={'file'} style={{ marginInlineEnd: '10px' }} />
              {
                i18n.t('phaseDocument', {
                  ns: 'companyManagement',
                }) as string
              }
            </span>
          }
          defaultOpen={true}
          nested={true}
        >
          {body}
        </Collapsible>
      ) : (
        body
      )}
      {openItem && (
        <DataContextProvider value={{ providerId: openItem.data.providerId }}>
          <TaskItemsViewer
            dispatch={appDispatch}
            onClose={setOpenItem}
            openItem={openItem}
            openItemProps={openItemProps}
          />
        </DataContextProvider>
      )}
    </span>
  );
};

const mapStateToProps: MapStateToProps<IStateToProps, IOwnProps, RootState> = (
  state,
  ownProps
) => {
  const providerItems = state.providers.items;
  const token = getAccessToken(state);
  const thisUser = state.thisUser;
  let tags = {} as ITags['data'];
  Object.values(ownProps.providers || {})?.forEach((p) => {
    tags = {
      ...tags,
      ...state.providers.tags[p.id]!.data,
    };
    return;
  });
  return { providerItems, token, thisUser, tags };
};

const mapDispatchToProps: MapDispatchToProps<
  IDispatchToProps,
  IOwnProps
> = () => {
  return {
    requireProviderItem: (providerItemId: number, token?: string) =>
      appDispatch(requireDocument({ documentId: providerItemId, token })),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClassFilePicker);
